module.exports = __webpack_public_path__ + "img/IEC13750.57fddcd4.png";